<template>
    <div role="status" class="max-w-sm animate-pulse">
        <div class="h-2.5 bg-gdc-gray-200 rounded-full w-48 mb-4"></div>
        <div class="h-2 bg-gdc-gray-200 rounded-full max-w-[360px] mb-2.5"></div>
        <div class="h-2 bg-gdc-gray-200 rounded-full mb-2.5"></div>
        <span class="sr-only">Loading...</span>
    </div>
</template>

<script type="text/javascript">
export default {
    name: "DefaultSkeleton"
}
</script>
